module.exports = __webpack_public_path__ + "static/img/news78_8.d97137d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/technology/news78/news78_8.webp
// module id = 225S
// module chunks = 0